import DAO from './DAO.js';
import StoreItemProcessing from '../helpers/StoreFunctions/StoreItemProcessing';
import _ from 'lodash';

export default class LocationUsersDAO extends DAO {

  constructor(store) {
    super(store, 'location_user');
    this.unsetLocationUsers = this.unsetLocationUsers.bind(this);
    this.clearLocationUsers = this.clearLocationUsers.bind(this);
  }

  unsetLocationUsers(id) {
    StoreItemProcessing.deleteItemInStore(this.itemType, id);
  }

  clearLocationUsers() {
    StoreItemProcessing.clearItemsInStore(this.itemType);
  }

  clearState(options) {
    this.clearMyState(this.stateTree.new_location_users, null, this.unsetLocationUsers, this.clearLocationUsers, options);
  }
}



// WEBPACK FOOTER //
// ./src/dao/LocationUsersDAO.js